import api from "services/api"

export const getDeliveryPartners = async (filters = {}) => {
  const { page, limit, search, sortOrder, ...restFilters } = filters
  const payload = {
    perPage: limit ?? 10,
    pageNo: page ?? 1,
    keyword: search,
    order: sortOrder,
    ...restFilters,
  }
  const response = await api.post("admin/delivery-partners/all", payload)
  return response.data
}

export const getPartnerDetails = async id => {
  const response = await api.post("admin/delivery-partners/details", { id })
  return response.data
}

export const getRiderPendingOrdersCount = async id => {
  const response = await api.get(`admin/delivery-partners/${id}/pending-orders-count`)
  return response.data
}

export const updatePartnerStatus = async (id, status, reason) => {
  const data = new FormData()
  data.append("status", status)
  if (reason) data.append("reason", reason)
  const response = await api.put(`admin/delivery-partners/${id}/update`, data)
  return response.data
}

export const createPartner = async payload => {
  const response = await api.post("admin/delivery-partners/add", payload)
  return response.data
}

export const updatePartner = async (id, payload) => {
  const response = await api.put(`admin/delivery-partners/${id}/update`, payload)
  return response.data
}

export const verifyDocument = async (partnerId, documentId, status, reason) => {
  const isReject = String(status).toLowerCase() === "rejected"
  const endpoint = isReject
    ? `admin/delivery-partners/${partnerId}/documents/${documentId}/reject`
    : `admin/delivery-partners/${partnerId}/documents/${documentId}/verify`
  const payload = isReject ? { reason } : { status: "Approved" }
  const response = await api.put(endpoint, payload)
  return response.data
}

export const getActiveDeliveries = async () => {
  const response = await api.get("admin/delivery-partners/active-deliveries")
  return response.data
}

export const getPartnerEarnings = async (id, period) => {
  const response = await api.get(`admin/delivery-partners/${id}/earnings/summary`, {
    params: { period },
  })
  return response.data
}

export const settleCOD = async (id, amount, date) => {
  const response = await api.post(`admin/delivery-partners/${id}/cod/settle`, {
    amount,
    settlementDate: date,
  })
  return response.data
}

export const getPartnerRatings = async (id, page) => {
  const response = await api.get(`admin/delivery-partners/${id}/ratings`, {
    params: { page },
  })
  return response.data
}

export const getPartnerOrders = async (id, params = {}) => {
  const response = await api.get(`admin/delivery-partners/${id}/orders`, {
    params: {
      status: params.status || "all",
      page: params.page || 1,
      limit: params.limit || 20,
      ...(params.dateRange ? { dateRange: params.dateRange } : {}),
    },
  })
  return response.data
}

export const getPartnerDailySummary = async (id, params = {}) => {
  const response = await api.get(`admin/delivery-partners/${id}/daily-summary`, {
    params: {
      date: params.date,
      page: params.page || 1,
      limit: params.limit || 50,
    },
  })
  return response.data
}

export const exportEarningsReport = async (filters = {}) => {
  const response = await api.get("admin/delivery-partners/export", {
    params: filters,
    responseType: "blob",
  })
  return response.data
}
